export default __webpack_public_path__ + "static/media/login.8a425eae.png";